import Vue from 'vue';
import App from './App.vue';
import router from './router';
import api from './network/api';
import './plugins/element.js';
import WdLogin from 'wd-login';
import 'wd-login/lib/wd-login.css';

Vue.config.productionTip = false;

Vue.prototype.$axios = api;
Vue.prototype.HOST = '/api';

Vue.use(WdLogin);

new Vue({
	router,
	render: h => h(App)
}).$mount('#app');
